import { RootState } from 'store';

export const selectClientProspectStatistics = ({ dashboard }: RootState) => dashboard.prospects.row;
